import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _1kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"1k"}/>
}
